import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

//fetch business information
export const fetchContentLibraryApi = async (coachId) => {
  const response = await axiosInstance.get(
    `${Endpoints.GET_CONTENT_LIBRARY}/${coachId}`
  );
  return response?.data?.data;
};

// Upsert content library data
export const postContentLibraryApi = async (payload) => {
  const response = await axiosInstance.post(
    Endpoints.POST_CONTENT_LIBRARY,
    payload
  );
  return response?.data?.data;
};

//Delete contents
export const deleteContentLibraryApi = async (id) => {
  const response = await axiosInstance.post(
    Endpoints.DELETE_CONTENT_LIBRARY,
    id
  );
  return response?.data;
};
